module.exports = __webpack_public_path__ + "static/media/signal.2bd22e80.svg";